import { Grid, Box, Center, Button, Text } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametersBudget from '@hook/budget/use-parameters'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import BarToggle from '@component/Modules/Budget/BarToggle'
import BudgetParameterModalConfig from '@component/Modules/Budget/ModalConfig'

import { disableActionsByDefault } from '@helper/budget/parameters/disableActionsByDefault'
const ConciliationBudget: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    actions,
    data,
    filename,
    pagination,
    dataBtLeo,
    handlePageChange,
    filters,
    typeGrid,
    headersMarge,
    saveUpdateBtLeo,
    dataMargeUpdate,
    saveUpdateMarge,
    dataMarge,
    getDataMargem,
    getData,
    updateBadge,
    textConclusionUpdate
  } = useParametersBudget()

  useEffect(() => {
    getFilters({
      yearBudget: true,
      monthBudget: true,
      historicBudget: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  useEffect(() => {
    getDataMargem()
  }, [getDataMargem])

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 187px)'
          : 'calc(100vh - 207px)'
        : hasSessions
        ? 'calc(100vh - 328px)'
        : 'calc(100vh - 348px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getFilters({
      yearBudget: true,
      monthBudget: true,
      historicBudget: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Orçamento Parâmetros">
      <Grid w="100vw" bg="white" h={height} templateColumns={'100vw'}>
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            isDisabled={loading || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <BarToggle />

              {typeGrid === 1 ? (
                <>
                  <GridQuantity
                    data={data}
                    textButton="Salvar"
                    disabled={dataBtLeo.length === 0}
                    onClick={saveUpdateBtLeo}
                  />

                  <TableGrid
                    id="purchase-budget-store"
                    headers={headers}
                    data={data}
                    height={tableHeight}
                    itsSortable={true}
                    entity="budget-parameter"
                    onSelect={handlePageChange}
                    pagination={pagination}
                    isPagedBack
                  />
                </>
              ) : (
                []
              )}

              {typeGrid === 2 ? (
                <>
                  <BudgetParameterModalConfig />

                  <GridQuantity
                    data={data}
                    textButton="Salvar"
                    disabled={dataMargeUpdate.length === 0}
                    onClick={saveUpdateMarge}
                  />

                  <TableGrid
                    id="purchase-budget-store"
                    headers={headersMarge}
                    data={dataMarge}
                    height={tableHeight}
                    itsSortable={true}
                    entity="budget-parameter-marge"
                    onSelect={handlePageChange}
                    pagination={pagination}
                    isPagedBack
                  />
                </>
              ) : (
                []
              )}

              {typeGrid === 3 ? (
                <>
                  <Center pt="28px">
                    <Button
                      size="md"
                      height="48px"
                      width="200px"
                      colorScheme="green"
                      variant="solid"
                      onClick={updateBadge}
                    >
                      ATUALIZAR
                    </Button>
                  </Center>
                  <br></br>
                  <Center>
                    <Text>{textConclusionUpdate}</Text>
                  </Center>
                </>
              ) : (
                []
              )}
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default ConciliationBudget
